












































/* eslint-disable class-methods-use-this */
/* eslint-disable @typescript-eslint/no-explicit-any */
import {
  Component, Vue, Watch,
} from 'vue-property-decorator';
import AddIcon from 'mdi-vue/Plus';
import dayjs from 'dayjs';
import excel from 'exceljs';
import { AxiosError } from 'axios';
import { mapState } from 'vuex';
import Table from '@/components/Table/Table.vue';
import TableBody from '@/components/Table/TableBody.vue';
import Row from '@/components/Table/Row.vue';
import Header from '@/components/Table/Header.vue';
import Cell from '@/components/Table/Cell.vue';
import Button from '@/components/Button.vue';
import Loader from '@/components/Loader.vue';
import StatusIndicator from '@/components/StatusIndicator.vue';
import SimplePagination from '@/components/SimplePagination.vue';
import ActionPopup from '@/components/ActionPopup.vue';
import ScrollbarWrapper from '@/components/ScrollbarWrapper.vue';

import api from '@/libs/api';
import format from '@/libs/numberFormat';
import {
  MerchantsMResponse, MerchantsManagement, User, Role,
} from '@/libs/api.interfaces';
import { showToast } from '@/libs/toast';
import { ToastType } from '@/store/toast';
import { DateRange } from '@/components/DatePicker.vue';

interface ReportParams {
  role_id: Role[];
  username: { key: string; value: string }[];
  merchant: { merchant_code: string; merchant_name: string }[] | null;
  transactionDate: DateRange;
}

@Component({
  components: {
    ScrollbarWrapper,
    Button,
    AddIcon,
    Table,
    TableBody,
    Row,
    Header,
    Cell,
    Loader,
    StatusIndicator,
    SimplePagination,
    ActionPopup,
  },
  methods: {
    format,
  },
  computed: mapState(['user']),
})
export default class ReportTable extends Vue {
  user!: {
    user: User;
  };

  channel = { title: '', code: '', path: '' };

  loading = true;
  listData: any[] = [];

  // pagination
  page = 1;
  tb: null | string = null;
  from = 0;
  to = 0;
  totalItem = 0;
  params: ReportParams = {} as ReportParams;

  statuses: { [key: string]: string } = {
    Success: 'Approved',
    Declined: 'Declined',
    'Filtered / Scrubbed': 'Filtered',
    'Processing Error / Internal Application Error': 'Error',
    'Cancelled (Query)': 'Cancelled',
    Pending: 'Pending',
    'Un-Processed': 'Un-Processed',
  }

  format!: (val: number) => string;

  // eslint-disable-next-line class-methods-use-this
  openDetail(id: string) {
    // window.open(`/account-management/edit/${id}`, '_blank');
    this.$router.push(`/account-management/edit/${id}`);
  }

  // @Watch('page')
  // onPageChange() {
  //   this.$router.push({
  //     query: { ...this.$route.query, page: this.page.toString() },
  //   });
  // }

  /* eslint-disable @typescript-eslint/camelcase */
  async getTransaction(params: ReportParams, isExport = false, page = 1, action: string | undefined = undefined) {
    try {
      console.log('username', params.username);
      this.loading = true;
      this.params = params;
      const merchant_code = params.merchant ? params.merchant.map((e) => e.merchant_code) : undefined;
      const role_id = params.role_id ? params.role_id.map((e) => e.id) : undefined;
      const username = params.username ? params.username.map((e) => e.value) : undefined;
      const first_id = action ? this.listData[0]?.id || undefined : undefined;
      const last_id = action ? this.listData[this.listData.length - 1]?.id || undefined : undefined;
      const transactionDate = {
        startDate: this.params.transactionDate.startDate === null ? undefined
          : dayjs(this.params.transactionDate.startDate).hour(0).minute(0).second(0)
            .format('YYYY-MM-DD HH:mm:ss'),
        endDate: this.params.transactionDate.endDate === null ? undefined
          : dayjs(this.params.transactionDate.endDate).hour(23).minute(59).second(59)
            .format('YYYY-MM-DD HH:mm:ss'),
        titleStart: this.params.transactionDate.startDate === null ? undefined
          : dayjs(this.params.transactionDate.startDate).format('DDMMYYYY'),
        titleEnd: this.params.transactionDate.endDate === null ? undefined
          : dayjs(this.params.transactionDate.endDate).format('DDMMYYYY'),
      };
      // eslint-disable-next-line max-len
      const { data } = await api.get(`/log-activity/${this.routeExternal || !this.isInternal ? 'external' : 'internal'}`, {
        params: {
          merchant_code,
          role_id,
          username,
          action,
          first_id,
          last_id,
          start_activity: transactionDate.startDate,
          end_activity: transactionDate.endDate,
        },
      });
      if (isExport) {
        return data;
      }

      // this.page = page;
      this.listData = data.data;
      // this.from = data.from;
      // this.to = data.to;
      this.totalItem = data.total;
      this.loading = false;

      return null;
    } catch (err) {
      console.error(err);
      return err as AxiosError;
    }
  }

  prev() {
    this.getTransaction(this.params, false, this.page, 'prev');
    this.page -= 1;
  }

  next() {
    this.getTransaction(this.params, false, this.page, 'next');
    this.page += 1;
  }

  // eslint-disable-next-line class-methods-use-this
  dateFormat(time: string) {
    const formatted = dayjs(time).format('MMMM D, YYYY HH:mm:ss');
    if (formatted === 'Invalid Date') {
      return '-';
    }

    return formatted;
  }

  get isInternal() {
    // console.log('route name', this.$route.name);
    // return this.$route.name === 'internal';
    return this.$store.state.user.user.is_internal === 1;
  }

  get routeExternal() {
    return this.$route.name === 'external';
  }
}
